module.exports = __webpack_public_path__ + "static/media/Acrilico (38).12b1ebf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (38).jpg
// module id = 306
// module chunks = 0